module.exports = __webpack_public_path__ + "img/terroir-inspect-medium.51b36607.jpg";